import styles from "../../styles/components/homePage.module.css";

const BlogCard = ({ blog }) => {
  return (
    <>
      <div className={styles.BlogCardContainer}>
        <a
          href={
            blog?.category
              ? `/blog/${blog?.category}/${blog?.slug}`
              : `/blog/${blog?.slug}`
          }
        >
          <a>
            <img src={blog?.coverImage} className={styles.postCover} />
          </a>
        </a>
        <div className={styles.top__content}>
          <a
            href={
              blog?.category
                ? `/blog/${blog?.category}/${blog?.slug}`
                : `/blog/${blog?.slug}`
            }
          >
            <a>
              <h2 className={styles.BlogTitle}>{blog?.title}</h2>
            </a>
          </a>

          <p className={styles.BlogDescription}>{blog?.excerpt}</p>
        </div>

        <div className={styles.Continuebtn}>
          <a
            href={
              blog?.category
                ? `/blog/${blog?.category}/${blog?.slug}`
                : `/blog/${blog?.slug}`
            }
          >
            <a className={styles.button}>Continue Reading</a>
          </a>
        </div>
      </div>
   
    </>
  );
};
export default BlogCard;
